<div [style.width.px]="width" style="display: contents" class="toolBar" #fixedHeader>
  <!--  [ngStyle]="production ? prodHeaderStyle : headerStyle"-->
  <mat-toolbar class="topbar">
    <button mat-mini-fab color="inherit" (click)="toggleSideNav()" class="d-flex justify-content-center">
      <i class="iconify icon-22 d-flex" data-icon="solar:hamburger-menu-line-duotone"></i>
    </button>

    <span class="toolBar-spacer"></span>
    <div class="icons" style="display: flex; align-items: center"
      [style.margin-right]="_translate.currentLang !== 'ar' ? '32px' : '0'"
      [style.margin-left]="_translate.currentLang === 'ar' ? '32px' : '0'">
      <!-- Desktop View - Show all icons -->
      <ng-container *ngIf="!isMobile">
        <div class="free-trial-wrapper" *ngIf="currentUser?.isFreeTrial && freeDaysCountdown !== null">
          <button type="button" class="free-trial-pill" [class.low]="freeDaysCountdown <= 3"
            (click)="onFreeTrialClick()" [attr.aria-label]="
              ('HEADER.FREE_DAYS_LEFT' | translate) + ' ' + freeDaysCountdown
            " [title]="('HEADER.FREE_DAYS_LEFT' | translate) + ' ' + freeDaysCountdown">
            <div class="pill-count">
              <span class="pill-value">{{ freeDaysCountdown }}</span>
              <span class="pill-unit">{{ "HEADER.DAYS" | translate }}</span>
            </div>
            <div class="pill-label">
              <span>{{ "HEADER.FREE_DAYS_LEFT" | translate }}</span>
            </div>
          </button>
        </div>

        <!-- @if (userType.isCustomer()) { -->
        <div tourAnchor="header.first">
          <button style="margin: 0 2px" mat-mini-fab color="inherit" (click)="openSub()"
            class="d-flex justify-content-center">
            <i class="iconify icon-22 d-flex" data-icon="material-symbols:card-membership-outline"
              style="font-size: 22px; color: inherit"></i>
          </button>
        </div>

        <!--       }-->
        @if (userType.isCustomer()) {
        <div tourAnchor="header.second">
          <button style="margin: 0 2px" mat-mini-fab color="inherit" (click)="openCustomerProgressDialog()"
            class="d-flex justify-content-center">
            <!-- <i
                class="iconify icon-22 d-flex"
                data-icon="material-symbols:card-membership-outline"
              ></i> -->
            <i class="iconify icon-22 d-flex" data-icon="heroicons-outline:cog"
              style="font-size: 22px; color: inherit"></i>
          </button>
        </div>
        }

        <!-- Guidance Toggle Button -->
        <button mat-mini-fab color="inherit" aria-label="toggle-guidance" class="d-flex justify-content-center"
          (click)="toggleGuidance()" [matTooltip]="
            isGuidanceVisible
              ? ('HEADER.HIDE_GUIDANCE' | translate)
              : ('HEADER.SHOW_GUIDANCE' | translate)
          " matTooltipPosition="below">
          <span [style.display]="isGuidanceVisible ? 'flex' : 'none'">
            <i class="iconify icon-22 d-flex" data-icon="material-symbols:help"
              style="font-size: 22px; color: inherit"></i>
          </span>
          <span [style.display]="!isGuidanceVisible ? 'flex' : 'none'">
            <i class="iconify icon-22 d-flex" data-icon="material-symbols:help-outline"
              style="font-size: 22px; color: inherit"></i>
          </span>
        </button>

        <!-- Run Guide Tour Button -->
        <button mat-mini-fab color="inherit" aria-label="run-guide-tour" class="d-flex justify-content-center"
          (click)="runGuideTour()" [matTooltip]="'HEADER.RUN_GUIDE' | translate" matTooltipPosition="below"
          style="margin: 0 2px">
          <i class="iconify icon-22 d-flex" data-icon="material-symbols:tour-outline"
            style="font-size: 22px; color: inherit"></i>
        </button>

        <!-- PWA Install Button -->
        <button *ngIf="showPwaInstallAction" mat-mini-fab color="inherit" aria-label="install-app"
          class="d-flex justify-content-center" (click)="onInstallAppClick()" [matTooltip]="
            manualInstallOnly
              ? ('HEADER.INSTALL_APP_HELP' | translate)
              : ('HEADER.INSTALL_APP' | translate)
          " matTooltipPosition="below" style="margin: 0 2px">
          <i class="iconify icon-22 d-flex" data-icon="material-symbols:download"
            style="font-size: 22px; color: inherit"></i>
        </button>

        <!-- Clear PWA Cache Button (online only) -->
        <button *ngIf="isOnline" mat-mini-fab color="inherit" aria-label="clear-cache"
          class="d-flex justify-content-center" (click)="clearPwaCache()"
          [matTooltip]="'HEADER.CLEAR_CACHE' | translate" matTooltipPosition="below" style="margin: 0 2px">
          <i class="iconify icon-22 d-flex" data-icon="material-symbols:refresh"
            style="font-size: 22px; color: inherit"></i>
        </button>

        <!-- AI Assistant Button -->
        <button mat-mini-fab color="inherit" aria-label="ai-assistant" class="d-flex justify-content-center"
          (click)="onAiAssistantClick()" matTooltip="{{ 'HEADER.AI_ASSISTANT' | translate }}" matTooltipPosition="below"
          style="margin: 0 2px">
          <app-ai-icon color="inherit" size="22" [animate]="true" style="width: 22px; height: 22px; color: inherit">
          </app-ai-icon>
        </button>

        <button mat-mini-fab color="inherit" aria-label="lightdark" class="d-flex justify-content-center"
          (click)="toggleTheme()">
          <i-tabler class="d-flex icon-22" [name]="themeService.isDarkMode ? 'sun' : 'moon'"></i-tabler>
        </button>

        <app-favorites-menu></app-favorites-menu>

        <app-notifications></app-notifications>
        <app-user-menu></app-user-menu>
        <app-languages [style.margin-left]="
            _translate.currentLang !== 'ar' ? '32px' : '16px'
          " [style.margin-right]="
            _translate.currentLang === 'ar' ? '32px' : '16px'
          ">
        </app-languages>
        <app-wifi-connection></app-wifi-connection>
      </ng-container>

      <!-- Mobile View - Show only 3 priority icons + dropdown -->
      <ng-container *ngIf="isMobile">
        <!-- Priority Icon 1: Theme Toggle -->
        <button mat-mini-fab color="inherit" aria-label="lightdark" class="d-flex justify-content-center mobile-icon"
          (click)="toggleTheme()">
          <i-tabler class="d-flex icon-22" [name]="themeService.isDarkMode ? 'sun' : 'moon'"></i-tabler>
        </button>

        <!-- Priority Icon 2: User Menu -->
        <app-user-menu class="mobile-icon"></app-user-menu>

        <!-- Priority Icon 3: Notifications -->
        <app-notifications class="mobile-icon"></app-notifications>

        <!-- Dropdown Icon 4: More options -->
        <div class="mobile-dropdown-container">
          <button mat-mini-fab color="inherit" aria-label="more-options"
            class="d-flex justify-content-center mobile-icon" (click)="toggleDropdown()"
            [class.active]="isDropdownOpen">
            <i class="iconify icon-22 d-flex" data-icon="material-symbols:more-vert"
              style="font-size: 22px; color: inherit"></i>
          </button>

          <!-- Dropdown Menu -->
          <div class="mobile-dropdown-menu" *ngIf="isDropdownOpen" [ngClass]="dropdownThemeClass">
            <div class="dropdown-backdrop" (click)="closeDropdown()"></div>
            <div class="dropdown-content" (click)="$event.stopPropagation()" [ngClass]="dropdownThemeClass">
              <!-- Free Trial Badge (if applicable) -->
              @if (currentUser.isFreeTrial) {
              <div class="dropdown-free-trial">
                <button mat-menu-item class="dropdown-item" (click)="onFreeTrialClick()">
                  <span [matBadge]="currentUser.remainingDay" [matBadgeHidden]="!currentUser.isFreeTrial"
                    matBadgeSize="small" class="dropdown-icon">
                    <i class="iconify" data-icon="fluent:hourglass-24-regular"></i>
                  </span>
                  <span class="dropdown-label">{{
                    "HEADER.FREE_TRIAL" | translate
                    }}</span>
                </button>
                <!-- <div class="dropdown-countdown" *ngIf="freeDaysCountdown !== null"> -->
                <!-- <div class="dropdown-countdown" >
                  <i class="iconify icon-20" data-icon="mdi:timer-sand"></i>
                  <span>Free days left: {{ freeDaysCountdown }}</span>
                </div> -->
              </div>
              }

              <!-- Subscription -->
              <button mat-menu-item class="dropdown-item" (click)="openSub(); closeDropdown()">
                <i class="iconify icon-22 dropdown-icon" data-icon="material-symbols:card-membership-outline"></i>
                <span class="dropdown-label">{{
                  "HEADER.SUBSCRIPTION" | translate
                  }}</span>
              </button>

              <!-- Settings (for customers) -->
              @if (userType.isCustomer()) {
              <button mat-menu-item class="dropdown-item" (click)="openCustomerProgressDialog(); closeDropdown()">
                <i class="iconify icon-22 dropdown-icon" data-icon="heroicons-outline:cog"></i>
                <span class="dropdown-label">{{
                  "HEADER.SETTINGS" | translate
                  }}</span>
              </button>
              }

              <!-- Guidance Toggle -->
              <button mat-menu-item class="dropdown-item" (click)="toggleGuidance(); closeDropdown()">
                <span [style.display]="isGuidanceVisible ? 'inline-block' : 'none'">
                  <i class="iconify icon-22 dropdown-icon" data-icon="material-symbols:help"></i>
                </span>
                <span [style.display]="!isGuidanceVisible ? 'inline-block' : 'none'">
                  <i class="iconify icon-22 dropdown-icon" data-icon="material-symbols:help-outline"></i>
                </span>
                <span class="dropdown-label">{{
                  isGuidanceVisible
                  ? ("HEADER.HIDE_GUIDANCE" | translate)
                  : ("HEADER.SHOW_GUIDANCE" | translate)
                  }}</span>
              </button>

              <!-- Run Guide Tour -->
              <button mat-menu-item class="dropdown-item" (click)="runGuideTour(); closeDropdown()">
                <i class="iconify icon-22 dropdown-icon" data-icon="material-symbols:tour-outline"></i>
                <span class="dropdown-label">{{
                  "HEADER.RUN_GUIDE" | translate
                  }}</span>
              </button>

              <!-- AI Assistant -->
              <button mat-menu-item class="dropdown-item" (click)="onAiAssistantClick(); closeDropdown()">
                <app-ai-icon class="dropdown-icon" color="inherit" size="22" [animate]="false">
                </app-ai-icon>
                <span class="dropdown-label">{{
                  "HEADER.AI_ASSISTANT" | translate
                  }}</span>
              </button>

              <!-- Install App -->
              <button *ngIf="showPwaInstallAction" mat-menu-item class="dropdown-item"
                (click)="onInstallAppClick(); closeDropdown()">
                <i class="iconify icon-22 dropdown-icon" data-icon="material-symbols:download"></i>
                <span class="dropdown-label">
                  {{
                  manualInstallOnly
                  ? ("HEADER.INSTALL_APP_HELP" | translate)
                  : ("HEADER.INSTALL_APP" | translate)
                  }}
                </span>
              </button>

              <!-- Clear PWA Cache (online only) -->
              <button *ngIf="isOnline" mat-menu-item class="dropdown-item" (click)="clearPwaCache(); closeDropdown()">
                <i class="iconify icon-22 dropdown-icon" data-icon="material-symbols:refresh"></i>
                <span class="dropdown-label">{{
                  "HEADER.CLEAR_CACHE" | translate
                  }}</span>
              </button>

              <!-- Favorites -->
              <div class="dropdown-item favorites-dropdown-item" [attr.data-label]="'HEADER.FAVORITES' | translate"
                (click)="isMobile ? favComp.openMenu() : null">
                <app-favorites-menu class="dropdown-icon" #favComp></app-favorites-menu>
                <span class="dropdown-label">{{
                  "HEADER.FAVORITES" | translate
                  }}</span>
              </div>

              <!-- Languages -->
              <div class="dropdown-item favorites-dropdown-item" [attr.data-label]="'HEADER.LANGUAGES' | translate"
                (click)="isMobile ? langComp.openMenu() : null">
                <app-languages class="dropdown-icon" #langComp></app-languages>
                <span class="dropdown-label">{{
                  "HEADER.LANGUAGES" | translate
                  }}</span>
              </div>

              <!-- WiFi Connection -->
              <div class="dropdown-item favorites-dropdown-item" [attr.data-label]="'HEADER.WIFI' | translate"
                (click)="isMobile ? wifiComp.triggerRefresh() : null">
                <app-wifi-connection class="dropdown-icon" #wifiComp></app-wifi-connection>
                <span class="dropdown-label">{{
                  "HEADER.WIFI" | translate
                  }}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </mat-toolbar>
</div>